import { render, staticRenderFns } from "./TrashCan.vue?vue&type=template&id=2c0de48b&scoped=true&"
var script = {}
import style0 from "./TrashCan.vue?vue&type=style&index=0&id=2c0de48b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0de48b",
  null
  
)

export default component.exports